import { Box, type BoxProps } from '@src/shared/ui/layout';

function SidebarContainer(props: BoxProps) {
  return <Box {...props} sx={StyleSheet.root} />;
}

SidebarContainer.displayName = 'SidebarContainer';

const StyleSheet = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
};

export default SidebarContainer;
